import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/collections/license.invoiceFollowUp.delete.mutation.gql"
import type {
  InvoiceFollowUpDeleteMutation,
  InvoiceFollowUpDeleteMutationVariables,
} from "@/v2-backoffice-client/license/collections/__types__/license.invoiceFollowUp.delete.mutation"

type Options = MutationHookOptions<
  InvoiceFollowUpDeleteMutation,
  InvoiceFollowUpDeleteMutationVariables
>

export function useInvoiceFollowUpDeleteMutation(options?: Options) {
  return useMutation<
    InvoiceFollowUpDeleteMutation,
    InvoiceFollowUpDeleteMutationVariables
  >(mutation, options)
}
